import Authentication from "@pitom84/integrations-services/src/classes/authentication/Authentication"
import { Service } from "../../config/service";
import UserService from "../users";

class AuthService extends Service {
    constructor() {
        super("login")
    }

    async login(email, password) {
        try {
            await Authentication.signInWithEmailAndPassword(email, password)
            if (!Authentication.emailIsVerified()) {
                // Authentication.sendEmailVerification()
                throw new Error("Seu e-mail ainda não foi validado, encaminhamos uma mensagem no seu e-mail para validar.")
            }
            const currentUser = Authentication.getCurrentUser()
            const { data } = await new UserService().getByIdOrEmail(currentUser.uid, currentUser.email)
            return data
        } catch (error) {
            this.setError(error)
            throw error
        }
    }

    async clearPermission(data, config = {}) {
        try {
            const response = await this.http84.post(this.getResource().insert, data, config)
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async forgotPassword(email, config = {}) {
        try {
            const response = await this.http84.post(`/reset-password-email`, { email }, config)
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async checkResetPasswordToken(token) {
        try {
            const response = await this.http84.get(`${this.getResource().get}/${token}`)
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async resetPassword(password) {
        try {
            const response = await this.http84.post(`/reset-password`, password)
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async resendConfirmationEmail(email) {
        try {
            const response = await this.http84.post(`/confirmation-email`, { email })
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async confirmEmail(token) {
        try {
            const response = await this.http84.post(`/confirm-email`, { token })
            return Promise.resolve(response)
        }
        catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async getStoreList(hash) {
        try {
            const url = `${this.getResource().root
                }/user/getStores/${hash}`;
            const response = this.http.get(url);
            return response;
        } catch (error) {
            this.setError(error);
            throw error
        }
    }

    async signOut() {
        await Authentication.signOut()
    }

    async insert(data, config = {}, api = "http") {
        try {
            const response = await this[api].post(`${this.getResource().insert}/user`, data, config)
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }
}

export default AuthService